import styled from "styled-components/macro";
import { CircularProgress, LinearProgress } from "@material-ui/core";
export const FONT_SIZE = 16;

export const SpinnerWrapper = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const CircularProgressStyled = styled(CircularProgress)`
  margin: 1rem;
`;

export const LinearProgressStyled = styled(LinearProgress)<{ opacity: number }>`
  margin: 2rem 0;
  opacity: ${(p) => p.opacity || 1};
`;

export const SimpleSpinnerContainer = styled("div")``;

export const SimpleSpinnerFullContainer = styled(SimpleSpinnerContainer)`
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
`;
